import React from 'react'
import { COLUMN_DATATYPE_NAMES, matchColumnType } from '../common/Utilities';

class ColumnMatcher extends React.Component {

    getMatchedColumn = (index, propName) => {
        const item = this.props.item;
        const selectedKey = this.props.selectedKey;
        const csvColumnMatch = this.props.upload.csvColumnMatch[selectedKey];
        if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single) {
            if (typeof(csvColumnMatch[index]) !== "undefined") {
                return csvColumnMatch[index];
            }
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff || matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo) {
            if (typeof(csvColumnMatch[index]) !== "undefined") {
                if (typeof(csvColumnMatch[index][propName]) !== "undefined") {
                    return csvColumnMatch[index][propName]; // array[i].off or array[i].on = index;
                }
            }
        }
        return "";
    }

    getMatchedColumnClass = (index, propName) => {
        return this.getMatchedColumn(index, propName) === "" ? "font-normal" : "matched-column-label"
    }

    getMatchedColumnTitle = (index, propName) => {
        const csvColumnNames = this.props.upload.csvColumnNames;
        const item = this.props.item;
        const i = this.getMatchedColumn(index, propName);
        const title = i === "" ? "" : csvColumnNames[i];
        if (title === "") {
            return "";
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single) {
            return `Automatically matched with: ${title}`;
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff || matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo) {
            return `Automatically matched with: ${title}`;
        } else {
            return "";
        }
    }

    onChange = (e, index, propName) => {
        const item = this.props.item;
        const selectedKey = this.props.selectedKey;
        const csvColumnMatch = this.props.upload.csvColumnMatch;
        if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single) {
            csvColumnMatch[selectedKey][index] = parseInt(e.target.value);
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff || matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo) {
            if (typeof(csvColumnMatch[selectedKey][index]) === "undefined") csvColumnMatch[selectedKey][index] = {};
            csvColumnMatch[selectedKey][index][propName] = parseInt(e.target.value);
        }

        this.props.onMatchingChange(csvColumnMatch);
    }
    render() {
    let {item,index,upload} = this.props;
    return (
    <th key={ index }>
    <div>
        {item.ColumnName.S}
        {upload.sample.length>0 && <table className="matcher"><tbody>
            { matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single &&
            <tr>
                <td className={this.getMatchedColumnClass(index)} title={this.getMatchedColumnTitle(index)}>{item.DataType.S}:</td>
                <td>
                {
                    <div>
                                    <select style={{ 'width': '200px' }} defaultValue={this.getMatchedColumn(index)} onChange={(e) => this.onChange(e, index)}>
                        <option key=""></option>
                        {
                            upload.csvColumnNames.map(function(item, cnameIndex) {
                                return <option key={cnameIndex} value={cnameIndex}>{item}</option>
                            })
                        }
                    </select>
                    </div>
                }
                </td>
            </tr>
            }
            { matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff &&
            <tr>
            <td className="font-normal">{item.DataType.S}:</td>
            <td>
            {
                <div>
                    <table>
                        <tbody>
                            <tr>
                                                <td  className={this.getMatchedColumnClass(index, "off")} title={this.getMatchedColumnTitle(index, "off")}>Off</td>
                                <td>
                                                    <select style={{ 'width': '200px' }} defaultValue={this.getMatchedColumn(index, "off")} onChange={(e) => this.onChange(e,index,"off")}>
                                        <option key=""></option>
                                        {
                                            upload.csvColumnNames.map(function(item, cnameIndex) {
                                                return <option key={cnameIndex} value={cnameIndex}>{item}</option>
                                            })
                                        }
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                                <td className={this.getMatchedColumnClass(index, "on")} title={this.getMatchedColumnTitle(index, "on")}>On</td>
                                <td>
                                                    <select style={{ 'width': '200px' }} defaultValue={this.getMatchedColumn(index, "on")} onChange={(e) => this.onChange(e,index,"on")}>
                                        <option key=""></option>
                                        {
                                            upload.csvColumnNames.map(function(item, cnameIndex) {
                                                return <option key={cnameIndex} value={cnameIndex}>{item}</option>
                                            })
                                        }
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                }
                </td>
            </tr>
            }
            { matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo &&
            <tr>
            <td className="font-normal">{item.DataType.S}:</td>
            <td>
            {
                <div>
                    <table >
                        <tbody>
                            <tr>
                                                <td className={this.getMatchedColumnClass(index, "latitude")} title={this.getMatchedColumnTitle(index, "latitude")}>latitude</td>
                                <td>
                                                    <select style={{ 'width': '200px' }} defaultValue={this.getMatchedColumn(index, "latitude")}  onChange={(e) => this.onChange(e,index,"latitude")}>
                                        <option key=""></option>
                                        {
                                            upload.csvColumnNames.map(function(item, cnameIndex) {
                                                return <option key={ cnameIndex } value={cnameIndex}>{item}</option>
                                            })
                                        }
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className={this.getMatchedColumnClass(index, "longitude")} title={this.getMatchedColumnTitle(index, "longitude")}>longitude</td>
                                <td>
                                                    <select style={{ 'width': '200px' }} defaultValue={this.getMatchedColumn(index, "longitude")}  onChange={(e) => this.onChange(e,index,"longitude")}>
                                        <option key=""></option>
                                        {
                                            upload.csvColumnNames.map(function(item, cnameIndex) {
                                                return <option key={ cnameIndex } value={cnameIndex}>{item}</option>
                                            })
                                        }
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                }
                </td>
            </tr>
            }
            { matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.undefined &&
                <tr><td style={{backgroundColor:"green"}}>{item.DataType.S}:</td><td></td></tr>
            }
        </tbody></table>
        }
    </div>
    </th>
    );
    }
}

export default ColumnMatcher;
